import Container from "./ui/Container";
import { PrimaryButton } from "./ui/Buttons";
import { useNavigate } from "react-router-dom";

interface HeroProps {
    fullScreen?: boolean;
}

export default function Hero({ fullScreen = false }: HeroProps) {
    const navigate = useNavigate();
    return (
        <section
            id="home"
            className={`bg-gradient-to-r from-blue-500 to-indigo-500 text-white ${
                fullScreen ? "h-screen flex items-center justify-center" : "py-24"
            }`}
        >
            <Container className={`text-center ${fullScreen ? "py-0" : ""}`}>
                <h1 className="text-4xl sm:text-5xl font-bold mb-6">
                    Your Trusted Partner in Finance & Real Estate
                </h1>
                <p className="text-lg mb-8">Loans, Insurance, Thawa FSPL and Thawa Housing Private Ltd. Solutions</p>
                <PrimaryButton onClick={() => navigate("/contact")}>Get Started</PrimaryButton>
            </Container>
        </section>
    );
}
